import { Observable } from "rxjs";
import { defaultIfEmpty, map } from "rxjs/operators";

import { TypeSystem } from "../../support/type-system.support";

    /**
     * @description
     *  Emite un valor por defecto si un observable completa sin emitir un
     *  valor o si el valor que emite es 'null' o 'undefined'. En cualquier
     *  otro caso, simplemente emite el mismo valor que la fuente.
     *
     * @param defaultValue
     *  El valor por defecto a emitir.
     *
     * @returns
     *  Un observable al cual encadenar más operadores, o al cual
     *  subscribirse.
     */

export function orElse<T>(defaultValue: T): (source: Observable<T>) => Observable<T> {
    return function (source: Observable<T>): Observable<T> {
        return source.pipe(
            defaultIfEmpty(defaultValue),
            map((value: T) => TypeSystem.orElse(value, defaultValue)));
    };
}
